import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider, themes } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import PaletteIcon from '@mui/icons-material/Palette';
import { dracula } from '../theme/dracula';
import { EdsLightThemeProvider, EdsDarkThemeProvider } from '../theme/eds/eds';

const themesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    ThemeBlueprint.make({
      name: 'dark',
      params: {
        theme: {
          id: 'default-dark',
          title: 'Dark',
          variant: 'dark',
          icon: <DarkModeIcon />,
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={themes.dark}>
              {children}
            </UnifiedThemeProvider>
          ),
        },
      },
    }),
    ThemeBlueprint.make({
      name: 'light',
      params: {
        theme: {
          id: 'default-light',
          title: 'Light',
          variant: 'light',
          icon: <LightIcon />,
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={themes.light}>
              {children}
            </UnifiedThemeProvider>
          ),
        },
      },
    }),
    ThemeBlueprint.make({
      name: 'dracula',
      params: {
        theme: {
          id: 'dracula',
          title: 'dracula',
          variant: 'dark',
          icon: <DarkModeIcon />,
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={dracula} themeName="dracula">
              {children}
            </UnifiedThemeProvider>
          ),
        },
      },
    }),
    ThemeBlueprint.make({
      name: 'eds-light',
      params: {
        theme: {
          id: 'eds-light',
          title: 'EDS Light',
          variant: 'light',
          icon: <PaletteIcon />,
          Provider: EdsLightThemeProvider,
        },
      },
    }),
    ThemeBlueprint.make({
      name: 'eds-dark',
      params: {
        theme: {
          id: 'eds-dark',
          title: 'EDS Dark',
          variant: 'dark',
          icon: <PaletteIcon />,
          Provider: EdsDarkThemeProvider,
        },
      },
    }),
  ],
});

export default themesModule;
